var map = {
	"./beetronix-white.png": 1451,
	"./contact-phone.webp": 9747,
	"./hero-bee.webp": 3963,
	"./logo-acacia.webp": 7742,
	"./logo-edunix.webp": 8875,
	"./logo-emerald.webp": 2180,
	"./logo-full-light.png": 8819,
	"./logo-full.png": 8744,
	"./logo-mark.svg": 1075,
	"./logo-octopharma.webp": 8690,
	"./mod-commercial-01.webp": 3745,
	"./mod-commercial-02.webp": 2148,
	"./mod-commercial-03.webp": 6327,
	"./mod-commercial-04.webp": 698,
	"./mod-commercial-05.webp": 8229,
	"./mod-commercial-06.webp": 5176,
	"./mod-education-01.webp": 3347,
	"./mod-education-02.webp": 8002,
	"./mod-education-03.webp": 1565,
	"./mod-education-04.webp": 5372,
	"./mod-education-05.webp": 6959,
	"./mod-education-06.webp": 3614,
	"./mod-industrial-01.webp": 5454,
	"./mod-industrial-02.webp": 4751,
	"./mod-industrial-03.webp": 3884,
	"./mod-industrial-04.webp": 6061,
	"./mod-industrial-05.webp": 4722,
	"./mod-industrial-06.webp": 8995,
	"./mod-medical-01.webp": 1728,
	"./mod-medical-02.webp": 381,
	"./mod-medical-03.webp": 466,
	"./mod-medical-04.webp": 5775,
	"./mod-medical-05.webp": 7836,
	"./mod-medical-06.webp": 5801,
	"./partner-commercial-01.webp": 7867,
	"./partner-commercial-02.webp": 8522,
	"./partner-commercial-03.webp": 389,
	"./partner-commercial-04.webp": 4308,
	"./partner-commercial-05.webp": 8007,
	"./partner-commercial-06.webp": 102,
	"./partner-commercial-07.webp": 4945,
	"./partner-commercial-08.webp": 2352,
	"./partner-commercial-09.webp": 9107,
	"./partner-commercial-10.webp": 2437,
	"./partner-commercial-11.webp": 8266,
	"./partner-commercial-12.webp": 635,
	"./partner-commercial-13.webp": 2264,
	"./partner-commercial-14.webp": 5169,
	"./partner-commercial-15.webp": 8790,
	"./partner-commercial-16.webp": 9463,
	"./partner-commercial-17.webp": 8452,
	"./partner-commercial-18.webp": 4029,
	"./partner-commercial-19.webp": 9314,
	"./partner-commercial-20.webp": 6910,
	"./partner-commercial-21.webp": 6009,
	"./partner-commercial-22.webp": 5340,
	"./partner-commercial-23.webp": 6207,
	"./partner-commercial-24.webp": 6178,
	"./partner-commercial-25.webp": 7517,
	"./partner-commercial-26.webp": 4688,
	"./partner-commercial-27.webp": 451,
	"./partner-education-01.webp": 581,
	"./partner-education-02.webp": 1176,
	"./partner-education-03.webp": 9115,
	"./partner-education-04.webp": 9990,
	"./partner-education-05.webp": 9745,
	"./partner-education-06.webp": 4500,
	"./partner-education-07.webp": 8679,
	"./partner-education-08.webp": 8050,
	"./partner-education-09.webp": 3613,
	"./partner-education-10.webp": 3231,
	"./partner-education-11.webp": 2988,
	"./partner-education-12.webp": 6025,
	"./partner-education-13.webp": 4590,
	"./partner-education-14.webp": 7651,
	"./partner-education-15.webp": 896,
	"./partner-education-16.webp": 5565,
	"./partner-education-17.webp": 2,
	"./partner-education-18.webp": 2903,
	"./partner-education-19.webp": 2852,
	"./partner-education-20.webp": 6932,
	"./partner-education-21.webp": 9527,
	"./partner-education-22.webp": 9094,
	"./partner-education-23.webp": 4417,
	"./partner-education-24.webp": 2504,
	"./partner-education-25.webp": 9883,
	"./partner-education-26.webp": 7994,
	"./partner-education-27.webp": 8613,
	"./partner-education-28.webp": 5692,
	"./partner-education-29.webp": 3631,
	"./partner-education-30.webp": 8561,
	"./partner-education-31.webp": 9686,
	"./partner-education-32.webp": 5159,
	"./partner-industrial-01.webp": 5724,
	"./partner-industrial-02.webp": 9993,
	"./partner-industrial-03.webp": 3966,
	"./partner-industrial-04.webp": 9251,
	"./partner-industrial-05.webp": 9840,
	"./partner-industrial-06.webp": 2669,
	"./partner-industrial-07.webp": 7954,
	"./partner-industrial-08.webp": 1751,
	"./partner-industrial-09.webp": 740,
	"./partner-industrial-10.webp": 6858,
	"./partner-industrial-11.webp": 7957,
	"./partner-industrial-12.webp": 3560,
	"./partner-industrial-13.webp": 6379,
	"./partner-industrial-14.webp": 8022,
	"./partner-industrial-15.webp": 2753,
	"./partner-medical-01.webp": 3938,
	"./partner-medical-02.webp": 9897,
	"./partner-medical-03.webp": 2448,
	"./partner-medical-04.webp": 2374,
	"./partner-medical-05.webp": 270,
	"./partner-medical-06.webp": 2719,
	"./partner-medical-07.webp": 9276,
	"./partner-medical-08.webp": 9218,
	"./partner-medical-09.webp": 5738,
	"./partner-medical-10.webp": 2528,
	"./partner-medical-11.webp": 5571,
	"./partner-medical-12.webp": 674,
	"./service-01.webp": 1875,
	"./service-02.webp": 4226,
	"./service-03.webp": 8941,
	"./service-04.webp": 1996,
	"./service-05.webp": 6879,
	"./team-collage.webp": 6731,
	"./value-01.webp": 1405,
	"./value-02.webp": 3088,
	"./value-03.webp": 3491,
	"./value-04.webp": 430,
	"./value-05.webp": 1865,
	"./value-06.webp": 8828,
	"./world-map.webp": 4141
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9688;